import { useEffect, useState } from 'react';
import '../App.css';
import logoGenlBlanco from '../assets/logo_genl_blanco.svg';
import iconFacebook from '../assets/icon-facebook.png';
import iconInstagram from '../assets/icon-instagram.png';
import iconTwitter from '../assets/icon-twitter.png';
import iconTelegram from '../assets/icon-telegram.png';
import iconTiktok from '../assets/icon-tiktok.png';
import iconYoutube from '../assets/icon-youtube.png';
import { Link } from "react-router-dom";
import { Box, Container, Accordion, AccordionSummary, AccordionDetails, Typography, Link as LinkMui } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

// Mapea nombres a imágenes
const iconMap: Record<string, string> = {
  iconFacebook,
  iconInstagram,
  iconTwitter,
  iconTelegram,
  iconTiktok,
  iconYoutube,
};

const Header = ({ links }: { links: any[] }) => {
  const redesLinks = links.filter((l) => l.zona === 'REDES' && l.es_icono === 1);
  const topLinks = links.filter((l) => l.zona === 'TOP');
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <>
      {/* 🔝 Barra gris superior */}
      <Box sx={{ width: "100%", background: "#e5e5e5" }}>
        <Container maxWidth="lg">
          <Accordion elevation={0} sx={{ background: "transparent" }}>
            <AccordionSummary
              sx={{
                minHeight: "auto",
                padding: 0,
                "& .MuiAccordionSummary-content": {
                  marginTop: 1, marginBottom: 1
                },
                "&.Mui-expanded": {
                  minHeight: "auto"
                },
                "& .MuiAccordionSummary-content.Mui-expanded": {
                  marginTop: 1, marginBottom: 1
                }
              }}
            >
              <Box sx={{ width: "fit-content", color: "#73839C", fontWeight: "bolder" }}>
                <Typography sx={{ fontSize: 11 }}>
                  Este es un sitio web oficial del Gobierno del Estado de Nuevo León.{" "}
                  <LinkMui href="#" sx={{ textDecoration: "underline" }}>
                    Aprende a identificarlo
                  </LinkMui>
                </Typography>
              </Box>
            </AccordionSummary>

            <AccordionDetails>
              <Box sx={{ display: "flex", flexDirection: { xs: "column", md: "row" }, gap: 2 }}>

                <Typography variant="body2" sx={{ fontSize: 12 }}>
                  Los sitios web oficiales del Gobierno de Nuevo León están adheridos al dominio{" "}
                  <LinkMui href="https://www.nl.gob.mx/" target="_blank" rel="noopener">
                    nl.gob.mx
                  </LinkMui>
                </Typography>

                <Typography variant="body2" sx={{ fontSize: 14 }}>
                  Todos los sitios web oficiales del Gobierno de Nuevo León cuentan con certificado de seguridad.
                </Typography>

              </Box>
            </AccordionDetails>
          </Accordion>

        </Container>
      </Box>

      {/* 🟧 HEADER NARANJA */}
      <Box sx={{ width: "100%", background: "#ff8400" }}>
        <Container
          maxWidth="lg"
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 2
          }}
        >
          {/* LEFT */}
          <div className="left-logo-container" style={{ display: "flex", alignItems: "center", gap: 16 }}>
            <button
              className="hamburger"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Menú de navegación"
            >
              ☰
            </button>

            <div className="logo">
              <Link to="/">
                <img src={logoGenlBlanco} alt="Gobierno de Nuevo León" />
              </Link>
            </div>
          </div>

          {/* RIGHT NAV */}
          <nav className={`nav-menu ${menuOpen ? "open" : ""}`}>
            <ul style={{ display: "flex", gap: 24 }}>
              {topLinks.map((item, idx) => (
                <li key={idx}>
                  <a href={item.link} onClick={() => setMenuOpen(false)}>
                    {item.texto}
                  </a>
                </li>
              ))}
            </ul>
          </nav>
        </Container>
      </Box>
    </>
  );
};

export default Header;
